var defaults = require('./form-editor.component').defaults;


e360.controller('FormAddSurveyController', [
   '$scope',
   '$uibModalInstance',
   'l10n',
   'surveyItemsApi',
   'session',
   'toast',
   'surveyType',
   'formEditor',

   function ($scope, $uibModalInstance, l10n, surveyItemsApi, session, toast, surveyType, formEditor) {
      $scope.cancel = function () {
         $uibModalInstance.dismiss('cancel');
      };

      var internalKey = surveyType.substr(6);

      $scope.language = formEditor.language;
      $scope.model = {
         survey: {
            type: internalKey,
            brandId: session.getBrand().id,
            description: {}
         }
      };

      $scope.saving = false;
      $scope.initializing = true;

      $scope.setImport = function(obj) {
         $scope.import = obj.selected;
      };

      $scope.doImport = function() {
         if (!$scope.import.id) {
            return;
         }

         var type = 'survey' + $scope.import.type;
         var model = {};
         model.type = type;
         model.survey = $scope.import;

         var def = _.find(defaults.survey, function(s) {
            return s.type == type;
         });

         if (def) {
            model = angular.extend(def, model);
         }

         $uibModalInstance.close(model);
      };

      $scope.select = function(type) {
         $scope.model.type = 'survey' + type;
         $scope.model.survey.type = type;
      };

      $scope.save = function() {
         $scope.saving = true;

         var existingKeys = $scope.existing.map(function(existingItem){
            return existingItem.key;
         });
         var key = surveyItemsApi.keyFromLabel(l10n.getTranslatedConfig($scope.model.survey.description, $scope.language));
         key = surveyItemsApi.uniqueKey(key, existingKeys);
         $scope.model.survey.key = key ? key : 'error';

         surveyItemsApi
            .create($scope.model.survey)
            .then(function(res) {
               $scope.saving = false;

               var type = 'survey' + res.type;
               $scope.model.type = type;
               $scope.model.survey = res;

               var def = _.find(defaults.survey, function(s) {
                  return s.type == type;
               });

               if (def) {
                  $scope.model = angular.extend(def, $scope.model);
               }

               $uibModalInstance.close($scope.model);
            }, function(err) {
               $scope.saving = false;
               toast.error()
                  .title('Error creating survey item')
                  .formErrors(err)
                  .send();
            });
      };

      $scope.existing = [];
      surveyItemsApi
         .list(session.getBrand().id)
         .then(function(data) {
            _.each(data, function(survey) {
               if (internalKey == survey.type) {
                  survey.localized = l10n.getTranslatedConfig(survey.description, $scope.language);
                  $scope.existing.push(survey);
               }
            });

            $scope.existing.sort(function(a, b) {
               var p1 = l10n.getTranslatedConfig(a.description, $scope.language).toUpperCase();
               var p2 = l10n.getTranslatedConfig(b.description, $scope.language).toUpperCase();

               var o1 = a.type.toUpperCase();
               var o2 = b.type.toUpperCase();

               if (o1 < o2) return -1;
               if (o1 > o2) return 1;
               if (p1 < p2) return -1;
               if (p1 > p2) return 1;
            });

            $scope.initializing = false;
         });
   }
]);
